__turbopack_context__.v({
  "container": "wrapper-module__M11DyW__container",
  "wrapper": "wrapper-module__M11DyW__wrapper",
});
